module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_8017.3fe2dc62.png";